import { Box, Typography } from "@mui/material";
import CustomizedButton from "../components/Custom/CustomizedButton";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h5">ขออภัยไม่มีสิทธิ์เข้าถึงข้อมูล</Typography>
      <CustomizedButton
        variant="outlined"
        title="กลับหน้าหลัก"
        sx={{ mt: 3, mb: 10 }}
        onClick={() => navigate("/")}
      />
      <img src="/static/notFoundPic.svg" alt="Not Found"></img>
    </Box>
  );
};

export default NotFound;
